const scheme = 'mpr';

export default function(seriesNumber = 0,imageOrientationPatient, imagePosititionPatient = "center"){
    return `${scheme}:${seriesNumber}:${imageOrientationPatient}:${imagePosititionPatient}`
}